import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS } from 'mobx';
import { observer } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';

import { IconClose } from './Icons';

@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class Notify  extends Component  {

  @observable trans = { };

  @observable notify = {
    active : true,
    title : '',
    text : '',
    type : 'none'
  }

  constructor(props) {

    super(props)

    this.trans = this.props.dictionaryStorage.getCurrentLangDict;

    let scope = this;

    this.checked = this.props.checked;

    this.bindEvents();

  }

  bindEvents(){
    $(window).on('notify',(e,obj)=>{

      this.notify.title = obj.title;
      this.notify.text = obj.text;
      this.notify.active = true;
      this.notify.type = obj.type;

    })
  }

  @action closeNotify(){
    this.notify.active = false;
  }

  render() {

    const t = this.t;

    return (
      <div className={"Notify"}>
        {
        this.notify.active
        &&
        <div onClick={ () => { this.closeNotify()} } className={"Notify-container "  + ( this.notify.type ?  this.notify.type : 'none')  }>
              <h6 className="Notify-title"><span>{t(this.notify.title)}</span></h6>
              <div className="Notify-text"><p dangerouslySetInnerHTML={ { __html : t(this.notify.text) }}></p></div>
              <span className="Notify-close">
                {t('Close')}
                <IconClose/>
              </span>
        </div>
         }
      </div>
    );
  }
}


